module.exports = __webpack_public_path__ + "static/media/equa.5c337294.svg";